import { ReactComponent as LoadingIcon } from "../assets/analyze.svg";


const Loading = () => {
    return (
        <div className='w-full h-full flex justify-center items-center'>

            <div className='mb-12'>
                <div className='flex justify-center mb-4'>
                    <LoadingIcon className='animate-spin' />
                </div>
                <div className='text-xl'>Loading...</div>
            </div>

        </div>
    )

}

export default Loading